export const logoSliderInit = () => {
  if(document.querySelector('.logo-list')) {
    const logoSliders = document.querySelectorAll('.logo-list__slider');
  
    if(logoSliders) {
      logoSliders.forEach((item) => {
        const logoSlider = new window.splide(item, {
          type: 'loop',
          pagination: false,
          arrows: false,
          autoplay: true,
          rewind: true,
          autoWidth: true,
          focus: 'center',
          gap: '100px',
          padding: '100px',
          breakpoints: {
            575: {
              gap: '30px'
            },
            1279: {
              gap: '45px'
            },
            1919: {
              padding: '60px',
              gap: '80px'
            },
          }
        });
  
        logoSlider.mount();
      });
    }
  }
}